(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["ceramique-product"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('ceramique-product')) {
  customElements.define('ceramique-product', class extends HTMLElement {
    connectedCallback() {
      if (this.ready) return;
      this.ready = true;
      this.variants = JSON.parse(this.querySelector('[data-variants]').textContent);
      this.labels = JSON.parse(this.querySelector('[data-config]').textContent);
      this.setupGallery();
      this.select = this.querySelector('[data-variant]');
      this.money = new Intl.NumberFormat(this.dataset.locale || 'fr-CA', {style:'currency',currency:this.dataset.currency || 'CAD'});
      this.options = Array.from(this.querySelectorAll('[data-option]'));
      this.optionValues = this.options.map((_,i)=>[...new Set(this.variants.map(v=>v.options[i]))]);
      this.change = (event) => {
        const index=this.options.indexOf(event.target);
        const selected=this.options.map(s=>s.value);
        const matches=this.variants.filter(v=>v.options.every((value,i)=>i>index||value===selected[i]));
        const match=matches.find(v=>v.options.every((value,i)=>value===selected[i])) || matches[0];
        if(match)this.update(match.id,true);
      };
      this.pop = () => this.update(new URL(location.href).searchParams.get('variant') || this.dataset.initial, false);
      this.options.forEach(select=>select.addEventListener('change',this.change));
      this.querySelector('[data-add-section]').addEventListener('click',()=>this.addSection());
      this.querySelector('[data-boxes]').addEventListener('input',()=>{this.querySelector('[data-quantity]').value=this.querySelector('[data-boxes]').value;this.calculate(false);});
      this.addSection();
      this.querySelector('[data-waste]').addEventListener('change',()=>this.calculate(true));
      this.querySelector('[data-quantity]').addEventListener('input',()=>this.calculate(false));
      window.addEventListener('popstate',this.pop);
      this.querySelector('form').addEventListener('submit',e=>{
        if (!this.variant || !this.variant.available || !this.querySelector('[data-quantity]').checkValidity()) e.preventDefault();
      });
      this.pop();
    }
    disconnectedCallback() {window.removeEventListener('popstate',this.pop);}
    text(selector,value) {this.querySelector(selector).textContent=value;}
    update(id,history) {
      const v=this.variants.find(v=>String(v.id)===String(id)) || this.variants[0];
      if (!v) return;
      this.variant=v; this.select.value=v.id;
      this.options.forEach((select,index)=>{
        const values=this.optionValues[index].filter(value=>this.variants.some(candidate=>candidate.options[index]===value&&candidate.options.every((option,i)=>i>=index||option===v.options[i])));
        select.replaceChildren(...values.map(value=>{const option=document.createElement('option');option.value=value;option.textContent=value;option.selected=value===v.options[index];return option;}));
      });
      this.coverage=Number(String(v.coverage || '').replace(',','.'));
      this.text('[data-sku]',v.sku || '—');
      const state={'En inventaire':['stock','status_stock'],'Inventaire bas':['low','status_low'],'Sur commande':['order','status_order'],'En commande seulement':['order','status_order']}[v.status] || ['unknown','status_unknown'];
      const badge=this.querySelector('[data-status]'); badge.dataset.status=state[0];this.text('[data-status-text]',state[0]==='order'?'Sur commande':this.labels[state[1]]);
      const palette={stock:['#E6F4EA','#4D9436','Layer_1.svg?v=1775742292'],low:['#D1E7F2','#1B87AE','Layer_3.svg?v=1775746085'],order:['#F5E1C8','#EC8209','Layer_2.svg?v=1775742534']}[state[0]];
      badge.style.backgroundColor=palette?palette[0]:'#eee';badge.style.color=palette?palette[1]:'#333';
      this.querySelector('[data-status-circle]').style.backgroundColor=palette?palette[1]:'#777';
      const icon=this.querySelector('[data-status-icon]');icon.hidden=!palette;if(palette)icon.src='https://cdn.shopify.com/s/files/1/0799/1839/9707/files/'+palette[2];
      this.updateGallery(v);
      const hasCoverage=Number.isFinite(this.coverage)&&this.coverage>0;
      this.querySelector('[data-calculator]').hidden=!hasCoverage;this.querySelector('[data-fallback-total]').hidden=hasCoverage;
      this.querySelector('[data-square-label]').hidden=!hasCoverage;
      this.updatePrices(v,hasCoverage);
      const add=this.querySelector('[data-add]');add.disabled=!v.available;add.textContent=v.available?this.labels.add_label:this.labels.unavailable_label;
      const specs=this.querySelector('[data-specifications]'); specs.replaceChildren();
      const fields=[['sku_label',v.sku],['brand_label',v.brand],['coverage_label',hasCoverage?this.coverage+' '+this.labels.unit_label:null],['thickness_label',v.thickness],['length_label',v.length],['width_label',v.width],['rectified_label',v.rectified],['grade_label',v.grade]];
      for(const [label,value] of fields){if(value===null||value===undefined||value==='')continue;const row=document.createElement('div'),dt=document.createElement('dt'),dd=document.createElement('dd');dt.textContent=this.labels[label];dd.textContent=value;row.append(dt,dd);specs.append(row);}
      this.calculate(true);
      if(history){const url=new URL(location.href);url.searchParams.set('variant',v.id);window.history.replaceState({},'',url);}
      this.dispatchEvent(new CustomEvent('ceramique:variant:change',{bubbles:true,detail:{variant:v}}));
    }
    updatePrices(variant,hasCoverage) {
      const compareAt=variant.compareAt;
      const onSale=Number.isFinite(compareAt) && compareAt>0 && Number.isFinite(variant.price) && variant.price>=0 && compareAt>variant.price;
      const oldSquareCents=hasCoverage?compareAt/this.coverage:NaN;
      const showOldSquare=onSale && hasCoverage && Number.isFinite(oldSquareCents);
      const unit=hasCoverage?this.labels.box_label:this.labels.units_unknown;
      this.querySelector('[data-prices]').dataset.sale=String(onSale);
      this.querySelector('[data-sale-badge]').hidden=!onSale;
      this.text('[data-sale-badge-text]',onSale?Math.round((1-variant.price/compareAt)*100+Number.EPSILON*100)+'% de réduction':'');
      this.querySelector('[data-square-price-row]').hidden=!hasCoverage;
      this.text('[data-square-price]',hasCoverage?this.money.format(variant.price/100/this.coverage):'');
      this.text('[data-box-price]',this.money.format(variant.price/100));
      this.text('[data-box-label]',unit);
      this.querySelector('[data-square-compare-wrap]').hidden=!showOldSquare;
      this.querySelector('[data-box-compare-wrap]').hidden=!onSale;
      this.text('[data-square-compare]',showOldSquare?this.money.format(Math.round(oldSquareCents)/100):'');
      this.text('[data-box-compare]',onSale?this.money.format(compareAt/100):'');
      this.text('[data-box-compare-label]',onSale?unit:'');
      const currentLabel=onSale?(this.labels.sale_price_label || 'Prix réduit'):(this.labels.current_price_label || 'Prix courant');
      this.querySelectorAll('[data-current-price-label]').forEach(label=>label.textContent=currentLabel+' :');
    }
    setupGallery() {
      this.gallery=this.querySelector('[data-gallery]');
      this.galleryMedia=JSON.parse(this.querySelector('[data-gallery-media]').textContent);
      this.galleryLabels={
        tile:this.labels.gallery_tile || 'Photo de la variante',
        exact:this.labels.gallery_exact || 'Produit installé — variante sélectionnée',
        collection:this.labels.gallery_collection || 'Ambiance de collection — variante non garantie',
        missing:this.labels.gallery_missing || 'Photo de cette variante non disponible',
        error:this.labels.gallery_error || 'Image indisponible',
        count:this.labels.gallery_count || 'Photo {current} sur {total}'
      };
      this.gallery.querySelector('[data-gallery-prev]').addEventListener('click',()=>this.showGallery(this.galleryIndex-1));
      this.gallery.querySelector('[data-gallery-next]').addEventListener('click',()=>this.showGallery(this.galleryIndex+1));
      this.gallery.addEventListener('keydown',event=>{
        if(event.altKey || event.ctrlKey || event.metaKey || !this.gallerySlides || this.gallerySlides.length<2)return;
        const targets={ArrowLeft:this.galleryIndex-1,ArrowRight:this.galleryIndex+1,Home:0,End:this.gallerySlides.length-1};
        if(!Object.prototype.hasOwnProperty.call(targets,event.key))return;
        event.preventDefault();
        this.showGallery(targets[event.key]);
      });
    }
    updateGallery(variant) {
      const exact=[],collection=[];
      const isInstalled=alt=>/produit installé/i.test(alt);
      const tile=variant.image && !isInstalled(variant.alt || '') ? variant.image : null;
      const seen=new Set(tile?[tile]:[]);
      const candidates=this.galleryMedia.filter(media=>isInstalled(String(media.alt || ''))).map(media=>{
        const alt=String(media.alt || '');
        const markers=[...alt.matchAll(/\[sku:([^\[\]\r\n]+)\]/g)];
        const hasMarker=/\[\s*sku/i.test(alt);
        const valid=!hasMarker || (markers.length===1 && markers[0][1]===variant.sku && !/\[\s*sku/i.test(alt.replace(markers[0][0],'')));
        return {...media,alt,hasMarker,markers,valid};
      });
      const blockedSources=new Set(candidates.filter(media=>!media.valid).map(media=>media.src));
      const scopedSources=new Set(candidates.filter(media=>media.hasMarker).map(media=>media.src));
      for(const media of candidates){
        const {alt,hasMarker,markers}=media;
        if(!media.src || blockedSources.has(media.src) || (!hasMarker && scopedSources.has(media.src)) || seen.has(media.src))continue;
        seen.add(media.src);
        const label=hasMarker?this.galleryLabels.exact+' — '+variant.title:this.galleryLabels.collection;
        const description=hasMarker?alt.replace(markers[0][0],'').trim():alt;
        (hasMarker?exact:collection).push({src:media.src,label,alt:label+' — '+description,kind:hasMarker?'exact':'collection',id:media.id});
      }
      const label=(tile?this.galleryLabels.tile:this.galleryLabels.missing)+' — '+variant.title;
      this.gallerySlides=[{src:tile,label,alt:label,kind:'tile'},...exact,...collection];
      const controls=this.gallery.querySelector('[data-gallery-controls]');
      const single=this.gallerySlides.length<2;
      if(single && controls.contains(document.activeElement))this.gallery.focus({preventScroll:true});
      controls.hidden=single;
      controls.querySelectorAll('button').forEach(button=>button.disabled=single);
      this.showGallery(0,Boolean(this.galleryRendered));
    }
    showGallery(index,announce=true) {
      if(!this.gallerySlides || !this.gallerySlides.length)return;
      const total=this.gallerySlides.length;
      this.galleryIndex=(index+total)%total;
      const slide=this.gallerySlides[this.galleryIndex];
      const frame=this.gallery.querySelector('[data-gallery-slide]');
      const slot=this.gallery.querySelector('[data-gallery-image-slot]');
      const placeholder=this.gallery.querySelector('[data-gallery-placeholder]');
      const count=this.galleryLabels.count.replace('{current}',String(this.galleryIndex+1)).replace('{total}',String(total));
      frame.setAttribute('aria-label',count);
      frame.dataset.kind=slide.kind;
      frame.setAttribute('aria-busy',slide.src?'true':'false');
      this.gallery.querySelector('[data-gallery-caption]').textContent=slide.label;
      this.gallery.querySelector('[data-gallery-counter]').textContent=(this.galleryIndex+1)+' / '+total;
      this.gallery.querySelector('[data-gallery-announcement]').textContent=announce?count+'. '+slide.label:'';
      placeholder.textContent=this.galleryLabels.missing;
      placeholder.hidden=Boolean(slide.src);
      if(!slide.src){slot.replaceChildren();this.galleryRendered=true;return;}
      const existing=slot.querySelector('img');
      const image=!this.galleryRendered && existing && existing.getAttribute('src')===slide.src?existing:document.createElement('img');
      image.className='ceramique-image';
      image.alt=slide.alt;
      image.hidden=true;
      image.decoding='async';
      image.loading='eager';
      if(image!==existing){image.width=1400;image.height=1400;}
      const loaded=()=>{if(!slot.contains(image))return;image.hidden=false;placeholder.hidden=true;frame.setAttribute('aria-busy','false');};
      const failed=()=>{if(!slot.contains(image))return;image.hidden=true;placeholder.textContent=this.galleryLabels.error;placeholder.hidden=false;frame.setAttribute('aria-busy','false');};
      image.addEventListener('load',loaded,{once:true});
      image.addEventListener('error',failed,{once:true});
      if(image!==existing){image.src=slide.src;slot.replaceChildren(image);}
      this.galleryRendered=true;
      if(image.complete){if(image.naturalWidth)loaded();else failed();}
    }
    addSection() {
      const section=document.createElement('div');section.className='tnt-roll-section';
      const uid=this.id+'-measure-'+(this.sectionCount=(this.sectionCount||0)+1);
      section.innerHTML=`<div class="tnt-roll-grid"><div class="tnt-roll-field"><label for="${uid}-length">LONGUEUR</label><div class="tnt-roll-input-wrap"><input type="number" id="${uid}-length" class="tnt-length" placeholder="0" min="0" step="0.1" inputmode="decimal"><span>pi</span></div></div><div class="tnt-roll-multiply">×</div><div class="tnt-roll-field"><label for="${uid}-width">LARGEUR</label><div class="tnt-roll-input-wrap"><input type="number" id="${uid}-width" class="tnt-width" placeholder="0" min="0" step="0.1" inputmode="decimal"><span>pi</span></div></div><button type="button" class="tnt-remove-section" aria-label="Supprimer cette section">×</button></div>`;
      this.querySelector('[data-sections]').append(section);
      section.querySelectorAll('input').forEach(input=>input.addEventListener('input',()=>this.calculate(true)));
      section.querySelector('button').addEventListener('click',()=>{section.remove();this.calculate(true);});
    }
    calculate(fromArea) {
      if(!this.variant)return;
      const quantity=this.querySelector('[data-quantity]'),hasCoverage=Number.isFinite(this.coverage)&&this.coverage>0;
      let area=0;
      this.querySelectorAll('.tnt-roll-section').forEach(section=>{const length=Number(section.querySelector('.tnt-length').value),width=Number(section.querySelector('.tnt-width').value);if(Number.isFinite(length)&&Number.isFinite(width)&&length>0&&width>0)area+=length*width;});
      const adjusted=area*(this.querySelector('[data-waste]').checked?1.1:1);
      this.querySelector('[data-area]').value=adjusted.toFixed(2);
      if(fromArea&&hasCoverage)quantity.value=area>0?Math.max(1,Math.ceil(adjusted/this.coverage-Number.EPSILON*Math.max(1,adjusted/this.coverage)*4)):1;
      const empty=fromArea&&area<=0&&hasCoverage;
      const count=empty?0:Number(quantity.value),valid=Number.isSafeInteger(count)&&count>0;
      this.querySelector('[data-boxes]').value=empty?'':valid?count:quantity.value;
      this.text('[data-box-size]',hasCoverage?this.coverage:'0');
      this.text('[data-cover]',valid&&hasCoverage?(count*this.coverage).toFixed(2):'0');
      this.text('[data-total]',empty?this.money.format(0):valid?this.money.format(count*this.variant.price/100):'—');
      this.text('[data-unit-total]',empty?this.money.format(0):valid?this.money.format(count*this.variant.price/100):'—');
      this.text('[data-total-coverage]',valid&&hasCoverage?this.labels.coverage_label+' : '+new Intl.NumberFormat(this.dataset.locale,{maximumFractionDigits:2}).format(count*this.coverage)+' pi²':'');
    }
  });
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["footer"]) return;
  try {
    
  customElements.whenDefined('details-disclosure').then(() => {
    class MobileDisclosure extends DetailsDisclosure {
      constructor() {
        super();

        const collapseEnabled = this.dataset.collapse === 'true';
        if (!collapseEnabled) return;

        this.reset();
        window.addEventListener('on:breakpoint-change', this.reset.bind(this));
      }

      reset() {
        const isLargeScreen = window.matchMedia(theme.mediaQueries.md).matches;
        this.disclosure.open = isLargeScreen;

        if (isLargeScreen) {
          this.toggle.setAttribute('tabindex', '-1');
          this.querySelectorAll('.disclosure, .disclosure__title, .disclosure__panel, .disclosure__content').forEach((el) => {
            [...el.classList].filter((cl) => cl.indexOf('disclosure') === 0).forEach((cl) => {
              el.classList.remove(cl);
              el.classList.add(`mobile-${cl}`);
            });
          });
        } else {
          this.toggle.removeAttribute('tabindex');
          this.querySelectorAll('.mobile-disclosure, .mobile-disclosure__title, .mobile-disclosure__panel, .mobile-disclosure__content').forEach((el) => {
            [...el.classList].filter((cl) => cl.indexOf('mobile-disclosure') === 0).forEach((cl) => {
              el.classList.remove(cl);
              el.classList.add(cl.substr(7));
            });
          });
        }
      }
    }

    customElements.define('mobile-disclosure', MobileDisclosure);
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["mercier-product"] && !Shopify.designMode) return;
  try {
    
(() => {
  const dimensions = ['platform', 'grade', 'width', 'finish'];
  const statusDefinitions = new Map([
    ['En inventaire', ['stock', 'status_stock']],
    ['Inventaire bas', ['low', 'status_low']],
    ['Sur commande', ['order', 'status_order']]
  ]);
  const nonempty = value => typeof value === 'string' && value.trim().length > 0;
  const decimal = value => {
    if (!['string', 'number'].includes(typeof value)) return null;
    const raw = String(value).trim();
    if (!/^\d+(?:[.,]\d+)?$/.test(raw)) return null;
    const number = Number(raw.replace(',', '.'));
    return Number.isFinite(number) && number > 0 ? number : null;
  };
  const tuple = row => JSON.stringify(dimensions.map(name => row[name].key));
  const measurementOK = row => {
    const m = row.unitMeasurement;
    const coverage = decimal(row.coverage);
    const unit = value => String(value).toUpperCase().replace('²', '2');
    return coverage !== null && m && unit(m.quantityUnit) === 'FT2'
      && unit(m.referenceUnit) === 'FT2' && Number(m.referenceValue) === 1
      && decimal(m.quantityValue) === coverage && Number.isSafeInteger(row.unitPriceCents)
      && row.unitPriceCents > 0 && row.unitPriceCents === Math.round(row.priceCents / coverage);
  };
  class Matrix {
    constructor(data) {
      this.valid = data?.schemaVersion === 1 && data.complete === true && Array.isArray(data.records)
        && Number.isSafeInteger(data.expectedRecordCount) && data.expectedRecordCount === data.records.length;
      this.rows = [];
      this.ambiguous = new Set();
      const keys = new Map(), ids = new Map(), tuples = new Map(), labels = dimensions.map(() => new Map());
      for (const row of Array.isArray(data?.records) ? data.records : []) {
        if (row?.configurationVerified !== true) continue;
        if (!nonempty(row.key) || dimensions.some(name => !nonempty(row[name]?.key) || !nonempty(row[name]?.label))
          || !nonempty(row.finish?.family) || !nonempty(row.finish?.sheen)) { this.valid = false; continue; }
        this.rows.push(row);
        dimensions.forEach((name, index) => {
          const signature = name === 'finish' ? JSON.stringify([row[name].label, row[name].family, row[name].sheen]) : row[name].label;
          if (labels[index].has(row[name].key) && labels[index].get(row[name].key) !== signature) this.valid = false;
          labels[index].set(row[name].key, signature);
        });
        for (const [map, key] of [[keys, row.key], [tuples, tuple(row)], [ids, row.variantId]]) {
          if (!key) continue;
          if (map.has(key)) { this.ambiguous.add(row); this.ambiguous.add(map.get(key)); }
          else map.set(key, row);
        }
      }
    }
    choices(index, selected) {
      const unique = new Map();
      for (const row of this.rows) {
        if (dimensions.some((name, i) => i < index && row[name].key !== selected[name])) continue;
        const value = row[dimensions[index]];
        unique.set(value.key, value.label);
      }
      return [...unique].map(([key, label]) => ({key, label}));
    }
    reconcile(previous = {}, changedIndex = -1) {
      const selected = {...previous};
      for (let i = 0; i < dimensions.length; i++) {
        const choices = this.choices(i, selected);
        const name = dimensions[i];
        if (!choices.some(choice => choice.key === selected[name])) {
          if (i <= changedIndex) return null;
          selected[name] = choices[0]?.key || '';
        }
      }
      return selected;
    }
    matches(selected) { return this.rows.filter(row => dimensions.every(name => row[name].key === selected[name])); }
    resolve(selected) { const rows = this.matches(selected); return rows.length === 1 ? rows[0] : null; }
    issue(row) {
      if (!this.valid) return 'matrix';
      if (!row) return 'combination';
      if (this.ambiguous.has(row)) return 'ambiguous';
      if (!/^[1-9]\d*$/.test(row.variantId || '') || row.checks?.mapping !== true) return 'mapping';
      if (!nonempty(row.sku) || row.checks?.sku !== true) return 'sku';
      if (row.priceStatus !== 'verified' || row.checks?.price !== true || !Number.isSafeInteger(row.priceCents) || row.priceCents <= 0) return 'price';
      if (decimal(row.coverage) === null || row.checks?.coverage !== true || row.unit !== 'box') return 'coverage';
      if (!measurementOK(row)) return 'unit';
      const rule = this.rule(row);
      if (!rule) return 'quantity_rule';
      if (!statusDefinitions.has(row.status)) return 'status';
      if (row.available !== true) return 'unavailable';
      return '';
    }
    rule(row) {
      const r = row?.quantityRule || {min: 1, increment: 1, max: null};
      if (!Number.isSafeInteger(r.min) || r.min < 1 || !Number.isSafeInteger(r.increment) || r.increment < 1
        || r.min % r.increment !== 0 || (r.max != null && (!Number.isSafeInteger(r.max) || r.max < r.min))) return null;
      return r;
    }
    validQuantity(row, n) {
      const rule = this.rule(row);
      return !!rule && Number.isSafeInteger(n) && n >= rule.min && n % rule.increment === 0 && (rule.max == null || n <= rule.max);
    }
    boxes(row, area, waste) {
      const coverage = decimal(row?.coverage), rule = this.rule(row);
      if (!coverage || !rule || !Number.isFinite(area) || area < 0) return null;
      const ratio = area * (waste ? 1.1 : 1) / coverage;
      const raw = Math.ceil(ratio - Number.EPSILON * Math.max(1, ratio) * 4);
      const boxes = Math.max(rule.min, Math.ceil(raw / rule.increment) * rule.increment);
      return Number.isSafeInteger(boxes) ? boxes : null;
    }
  }
  if (typeof module !== 'undefined' && module.exports) { module.exports = {Matrix, decimal, measurementOK}; return; }
  if (customElements.get('mercier-product')) return;
  customElements.define('mercier-product', class extends HTMLElement {
    connectedCallback() {
      if (this.ready) { window.addEventListener('popstate', this.pop); return; }
      this.ready = true;
      this.form = this.querySelector('form');
      this.idInput = this.querySelector('[data-variant]');
      this.quantity = this.querySelector('[data-quantity]');
      this.add = this.querySelector('[data-add]');
      this.options = [...this.querySelectorAll('[data-option]')];
      this.labels = JSON.parse(this.querySelector('[data-config]').textContent);
      this.money = new Intl.NumberFormat(this.dataset.locale || 'fr-CA', {style: 'currency', currency: this.dataset.currency || 'CAD'});
      this.number = new Intl.NumberFormat(this.dataset.locale || 'fr-CA', {maximumFractionDigits: 2});
      try { this.matrix = new Matrix(JSON.parse(this.querySelector('[data-matrix]').textContent)); }
      catch { this.matrix = new Matrix(null); }
      this.productDocuments = JSON.parse(this.querySelector('[data-product-documents]').textContent);
      this.setupGallery();
      this.options.forEach((select, index) => select.addEventListener('change', () => {
        const previous = {...this.selected, [dimensions[index]]: select.value};
        this.selected = this.matrix.reconcile(previous, index);
        this.selectionError = this.selected ? '' : 'combination';
        this.update(true);
      }));
      this.querySelector('[data-add-section]').addEventListener('click', () => this.addSection(true));
      this.querySelector('[data-boxes]').addEventListener('input', event => { this.quantity.value = event.target.value; this.calculate(false); });
      this.quantity.addEventListener('input', () => this.calculate(false));
      this.querySelector('[data-waste]').addEventListener('change', () => this.calculate(true));
      this.form.addEventListener('submit', event => {
        this.calculate(false);
        const row = this.selected && this.matrix.resolve(this.selected);
        const safe = row && row === this.variant && !this.selectionError && !this.matrix.issue(row)
          && this.idInput.value === row.variantId && this.matrix.validQuantity(row, Number(this.quantity.value))
          && Number.isSafeInteger(Number(this.quantity.value) * row.priceCents) && this.measurementsValid;
        if (!safe) { event.preventDefault(); event.stopImmediatePropagation(); this.calculate(false); return; }
        this.idInput.value = row.variantId;
      }, true);
      this.pop = () => {
        const requested = new URL(location.href).searchParams.get('variant') || this.dataset.initial;
        const matches = requested ? this.matrix.rows.filter(row => row.variantId === requested) : [];
        const initial = matches.length === 1 ? matches[0] : !requested ? this.matrix.rows.find(row => !this.matrix.issue(row)) || this.matrix.rows[0] : null;
        this.selectionError = requested && !initial ? 'mapping' : '';
        this.selected = initial ? Object.fromEntries(dimensions.map(name => [name, initial[name].key])) : this.matrix.reconcile();
        this.update(false);
      };
      this.addSection(false);
      window.addEventListener('popstate', this.pop);
      this.pop();
    }
    disconnectedCallback() { window.removeEventListener('popstate', this.pop); }
    text(selector, value) { this.querySelector(selector).textContent = value; }
    update(history) {
      const active = document.activeElement;
      this.options.forEach((select, index) => {
        const choices = this.matrix.choices(index, this.selected || {});
        select.replaceChildren(...choices.map(choice => {
          const option = document.createElement('option'); option.value = choice.key; option.textContent = choice.label;
          option.selected = choice.key === this.selected?.[dimensions[index]]; return option;
        }));
        const wrapper = select.closest('[data-option-group]'), single = choices.length === 1;
        wrapper.querySelector('label').hidden = single;
        select.hidden = single;
        select.disabled = !choices.length;
        const plain = wrapper.querySelector('[data-option-static]');
        plain.hidden = !single;
        plain.textContent = single ? this.labels[dimensions[index] + '_label'] + ' : ' + choices[0].label : '';
        if (single && active === select) this.options.find((item, i) => i !== index && !item.hidden && !item.disabled)?.focus();
      });
      this.variant = this.selectionError ? null : this.selected && this.matrix.resolve(this.selected);
      const row = this.variant;
      this.issue = this.selectionError || this.matrix.issue(row);
      this.idInput.value = !this.issue ? row.variantId : '';
      this.idInput.disabled = !!this.issue;
      const canPrice = row && !this.matrix.ambiguous.has(row) && row.checks?.price === true && row.priceStatus === 'verified'
        && Number.isSafeInteger(row.priceCents) && row.priceCents > 0;
      const canCoverage = row && row.checks?.coverage === true && decimal(row.coverage) !== null;
      this.canPrice = canPrice;
      this.coverage = canCoverage ? decimal(row.coverage) : null;
      this.text('[data-sku]', row?.checks?.sku === true && nonempty(row.sku) ? row.sku : this.labels.confirm_label);
      this.text('[data-box-price]', canPrice ? this.money.format(row.priceCents / 100) : this.labels.price_pending);
      this.text('[data-square-price]', canPrice && measurementOK(row) ? this.money.format(row.unitPriceCents / 100) : this.labels.price_pending);
      this.querySelector('[data-square-label]').hidden = !(canPrice && measurementOK(row));
      this.querySelector('[data-box-label]').hidden = !canPrice;
      const compareAt = row?.compareAtPriceCents;
      const compareUnit = canPrice && canCoverage && measurementOK(row) && Number.isSafeInteger(compareAt)
        && compareAt > row.priceCents ? Math.round(compareAt / this.coverage) : null;
      const onSale = Number.isSafeInteger(compareUnit) && compareUnit > 0;
      this.querySelector('[data-sale-badge]').hidden = !onSale;
      this.text('[data-sale-badge-text]', onSale ? Math.round((1 - row.priceCents / compareAt) * 100) + '% de réduction' : '');
      this.querySelectorAll('[data-price-line]').forEach(line => line.classList.toggle('mercier-price--on-sale', onSale));
      this.querySelectorAll('[data-sale-only]').forEach(element => { element.hidden = !onSale; });
      this.text('[data-square-compare-price]', onSale ? this.money.format(compareUnit / 100) : '');
      this.text('[data-box-compare-price]', onSale ? this.money.format(compareAt / 100) : '');
      this.querySelector('[data-calculator]').hidden = !this.coverage;
      this.querySelector('[data-fallback-total]').hidden = !!this.coverage;
      this.updateBadge(row);
      this.updateGallery(row || {sku: '', title: '', image: null});
      this.updateDocuments(row);
      const specs = this.querySelector('[data-specifications]'); specs.replaceChildren();
      if (row) for (const [label, value] of [
        ['platform_label', row.platform.label], ['grade_label', row.grade.label], ['width_label', row.width.label],
        ['finish_family_label', row.finish.family], ['sheen_label', row.finish.sheen],
        ['coverage_label', this.coverage ? this.number.format(this.coverage) + ' pi² / boîte' : null]
      ]) {
        if (!value) continue;
        const item = document.createElement('div'), dt = document.createElement('dt'), dd = document.createElement('dd');
        dt.textContent = this.labels[label]; dd.textContent = value; item.append(dt, dd); specs.append(item);
      }
      const rule = this.matrix.rule(row);
      for (const input of [this.quantity, this.querySelector('[data-boxes]')]) {
        input.min = rule?.min || 1; input.step = rule?.increment || 1;
        if (rule?.max != null) input.max = rule.max; else input.removeAttribute('max');
      }
      this.calculate(true);
      if (history) {
        const url = new URL(location.href);
        if (row?.variantId && !this.matrix.ambiguous.has(row)) url.searchParams.set('variant', row.variantId); else url.searchParams.delete('variant');
        window.history.replaceState({}, '', url);
        this.text('[data-selection-announcement]', row ? dimensions.map(name => row[name].label).join(', ') : this.labels.issue_combination);
      }
      this.dispatchEvent(new CustomEvent('mercier:variant:change', {bubbles: true, detail: {variantId: this.idInput.value || null, recordKey: row?.key || null}}));
    }
    updateBadge(row) {
      const state = statusDefinitions.get(row?.status) || ['unknown', 'status_unknown'];
      const palette = {stock: ['#E6F4EA', '#4D9436', 'Layer_1.svg?v=1775742292'], low: ['#D1E7F2', '#1B87AE', 'Layer_3.svg?v=1775746085'], order: ['#F5E1C8', '#EC8209', 'Layer_2.svg?v=1775742534']}[state[0]];
      const badge = this.querySelector('[data-status]'); badge.dataset.status = state[0];
      this.text('[data-status-text]', this.labels[state[1]]);
      badge.style.backgroundColor = palette ? palette[0] : '#eee'; badge.style.color = '#222';
      this.querySelector('[data-status-circle]').style.backgroundColor = palette ? palette[1] : '#777';
      const icon = this.querySelector('[data-status-icon]'); icon.hidden = !palette;
      if (palette) icon.src = 'https://cdn.shopify.com/s/files/1/0799/1839/9707/files/' + palette[2];
      else icon.removeAttribute('src');
    }
    updateDocuments(row) {
      const documents = row?.documents == null ? this.productDocuments : row.documents;
      const wrapper = this.querySelector('[data-documents]');
      const list = wrapper.querySelector('.tnt-pdf-wrapper'); list.replaceChildren();
      for (const doc of Array.isArray(documents) ? documents : []) {
        let url;
        try { url = new URL(doc.url); } catch { continue; }
        if (url.protocol !== 'https:' || url.username || url.password || !nonempty(doc.title)) continue;
        const link = document.createElement('a'); link.href = url.href; link.target = '_blank';
        link.rel = 'noopener noreferrer'; link.className = 'tnt-pdf-link'; link.dataset.documentId = doc.id;
        const svg = document.createElementNS('http://www.w3.org/2000/svg', 'svg');
        svg.setAttribute('viewBox', '0 0 24 24'); svg.setAttribute('width', '18'); svg.setAttribute('height', '18');
        svg.setAttribute('aria-hidden', 'true'); svg.setAttribute('focusable', 'false');
        const path = document.createElementNS('http://www.w3.org/2000/svg', 'path');
        path.setAttribute('d', 'M14 2H6c-1.1 0-1.99.9-1.99 2L4 20c0 1.1.89 2 1.99 2H18c1.1 0 2-.9 2-2V8l-6-6zm2 16H8v-2h8v2zm0-4H8v-2h8v2zm-3-5V3.5L18.5 9H13z'); svg.append(path);
        const title = document.createElement('span'); title.textContent = doc.title;
        const help = document.createElement('span'); help.className = 'mercier-visually-hidden'; help.textContent = ' — ' + this.labels.new_tab_label;
        link.append(svg, title, help); list.append(link);
      }
      wrapper.hidden = !list.children.length;
    }
    addSection(focus) {
      const section = this.querySelector('[data-section-template]').content.firstElementChild.cloneNode(true);
      const uid = this.id + '-measure-' + (this.sectionCount = (this.sectionCount || 0) + 1);
      section.querySelectorAll('input').forEach((input, index) => {
        input.id = uid + '-' + index;
        input.closest('.tnt-roll-field').querySelector('label').htmlFor = input.id;
        input.addEventListener('input', () => this.calculate(true));
      });
      section.querySelector('button').addEventListener('click', () => {
        section.remove(); this.querySelector('[data-add-section]').focus(); this.calculate(true);
      });
      this.querySelector('[data-sections]').append(section);
      if (focus) section.querySelector('input').focus();
    }
    calculate(fromArea) {
      let area = 0;
      this.measurementsValid = true;
      this.querySelectorAll('.tnt-roll-section').forEach(section => {
        const inputs = [...section.querySelectorAll('input')];
        const filled = inputs.filter(input => input.value !== '');
        const valid = !filled.length || (filled.length === 2 && inputs.every(input => decimal(input.value) && input.checkValidity()));
        inputs.forEach(input => input.setAttribute('aria-invalid', String(!valid)));
        if (!valid) this.measurementsValid = false;
        if (valid && filled.length) area += Number(inputs[0].value) * Number(inputs[1].value);
      });
      if (!Number.isFinite(area)) this.measurementsValid = false;
      const adjusted = area * (this.querySelector('[data-waste]').checked ? 1.1 : 1);
      this.querySelector('[data-area]').value = this.measurementsValid ? this.number.format(adjusted) : '';
      if (fromArea && this.variant && this.coverage && this.measurementsValid) {
        const count = this.matrix.boxes(this.variant, area, this.querySelector('[data-waste]').checked);
        this.quantity.value = count ?? '';
      }
      const count = Number(this.quantity.value);
      const valid = this.matrix.validQuantity(this.variant, count);
      const totalSafe = this.canPrice && Number.isSafeInteger(count * this.variant.priceCents);
      this.querySelector('[data-boxes]').value = this.quantity.value;
      this.text('[data-box-size]', this.coverage ? this.number.format(this.coverage) : this.labels.confirm_label);
      this.text('[data-cover]', valid && this.coverage ? this.number.format(count * this.coverage) : '—');
      const total = valid && this.measurementsValid && totalSafe ? this.money.format(count * this.variant.priceCents / 100) : this.labels.confirm_label;
      this.text('[data-total]', total); this.text('[data-unit-total]', total);
      this.text('[data-total-coverage]', valid && this.coverage ? this.labels.coverage_label + ' : ' + this.number.format(count * this.coverage) + ' pi²' : '');
      const issue = this.issue || (!this.measurementsValid ? 'measurements' : (!valid || !totalSafe) ? 'quantity' : '');
      this.add.disabled = !!issue;
      this.add.textContent = issue ? this.labels.blocked_label : this.labels.add_label;
      const error = this.querySelector('[data-error]');
      error.hidden = !issue; error.textContent = issue ? this.labels['issue_' + issue] || this.labels.issue_matrix : '';
    }
    setupGallery() {
      this.gallery=this.querySelector('[data-gallery]');
      this.galleryMedia=JSON.parse(this.querySelector('[data-gallery-media]').textContent);
      this.galleryLabels={
        tile:this.labels.gallery_tile || 'Photo de la variante',
        exact:this.labels.gallery_exact || 'Produit installé — variante sélectionnée',
        collection:this.labels.gallery_collection || 'Ambiance de collection — variante non garantie',
        missing:this.labels.gallery_missing || 'Photo de cette variante non disponible',
        error:this.labels.gallery_error || 'Image indisponible',
        count:this.labels.gallery_count || 'Photo {current} sur {total}'
      };
      this.gallery.querySelector('[data-gallery-prev]').addEventListener('click',()=>this.showGallery(this.galleryIndex-1));
      this.gallery.querySelector('[data-gallery-next]').addEventListener('click',()=>this.showGallery(this.galleryIndex+1));
      this.gallery.addEventListener('keydown',event=>{
        if(event.altKey || event.ctrlKey || event.metaKey || !this.gallerySlides || this.gallerySlides.length<2)return;
        const targets={ArrowLeft:this.galleryIndex-1,ArrowRight:this.galleryIndex+1,Home:0,End:this.gallerySlides.length-1};
        if(!Object.prototype.hasOwnProperty.call(targets,event.key))return;
        event.preventDefault();
        this.showGallery(targets[event.key]);
      });
    }
    updateGallery(variant) {
      // Product media order is authoritative: installed room first, sample second.
      // Neither shared N/A codes nor a variant's featured image can remove or reorder it.
      const media = this.galleryMedia.filter(item => item && item.src);
      const photos = media.length ? media : (variant.image ? [{src: variant.image, alt: variant.alt}] : []);
      this.gallerySlides = photos.map(item => {
        const description = String(item.alt || '').replace(/\s*\[sku:[^\]]*\]/gi, '').trim();
        const label = description || this.labels.gallery_label || 'Photos du produit';
        const kind = /installé|ambiance/i.test(description) ? 'installed' : /échantillon/i.test(description) ? 'sample' : 'product';
        return {src: item.src, label, alt: label, kind, id: item.id};
      });
      if (!this.gallerySlides.length) this.gallerySlides = [{src: null, label: this.galleryLabels.missing, alt: '', kind: 'missing'}];
      const controls = this.gallery.querySelector('[data-gallery-controls]');
      const single = this.gallerySlides.length < 2;
      if (single && controls.contains(document.activeElement)) this.gallery.focus({preventScroll: true});
      controls.hidden = single;
      controls.querySelectorAll('button').forEach(button => button.disabled = single);
      this.showGallery(0, Boolean(this.galleryRendered));
    }
    showGallery(index,announce=true) {
      if(!this.gallerySlides || !this.gallerySlides.length)return;
      const total=this.gallerySlides.length;
      this.galleryIndex=(index+total)%total;
      const slide=this.gallerySlides[this.galleryIndex];
      const frame=this.gallery.querySelector('[data-gallery-slide]');
      const slot=this.gallery.querySelector('[data-gallery-image-slot]');
      const placeholder=this.gallery.querySelector('[data-gallery-placeholder]');
      const count=this.galleryLabels.count.replace('{current}',String(this.galleryIndex+1)).replace('{total}',String(total));
      frame.setAttribute('aria-label',count);
      frame.dataset.kind=slide.kind;
      frame.setAttribute('aria-busy',slide.src?'true':'false');
      this.gallery.querySelector('[data-gallery-caption]').textContent=slide.label;
      this.gallery.querySelector('[data-gallery-counter]').textContent=(this.galleryIndex+1)+' / '+total;
      this.gallery.querySelector('[data-gallery-announcement]').textContent=announce?count+'. '+slide.label:'';
      placeholder.textContent=this.galleryLabels.missing;
      placeholder.hidden=Boolean(slide.src);
      if(!slide.src){slot.replaceChildren();this.galleryRendered=true;return;}
      const existing=slot.querySelector('img');
      const image=!this.galleryRendered && existing && existing.getAttribute('src')===slide.src?existing:document.createElement('img');
      image.className='mercier-image';
      image.alt=slide.alt;
      image.hidden=true;
      image.decoding='async';
      image.loading='eager';
      if(image!==existing){image.width=1400;image.height=1400;}
      const loaded=()=>{if(!slot.contains(image))return;image.hidden=false;placeholder.hidden=true;frame.setAttribute('aria-busy','false');};
      const failed=()=>{if(!slot.contains(image))return;image.hidden=true;placeholder.textContent=this.galleryLabels.error;placeholder.hidden=false;frame.setAttribute('aria-busy','false');};
      image.addEventListener('load',loaded,{once:true});
      image.addEventListener('error',failed,{once:true});
      if(image!==existing){image.src=slide.src;slot.replaceChildren(image);}
      this.galleryRendered=true;
      if(image.complete){if(image.naturalWidth)loaded();else failed();}
    }
  });
})();


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["related-products"]) return;
  try {
    
var loadProductRecommendationsIntoSection = function() {
  // Look for an element with class 'related-products'
  var productRecommendationsSection = document.querySelector(".related-products");
  if (productRecommendationsSection === null) { return; }
  // Create request and submit it using Ajax
  var request = new XMLHttpRequest();
  request.open("GET", productRecommendationsSection.dataset.url);
  request.onload = function() {
    if (request.status >= 200 && request.status < 300) {
      var container = document.createElement("div");
      container.innerHTML = request.response;
      productRecommendationsSection.innerHTML = container.querySelector(".related-products").innerHTML;
    }
  };
  request.send();
};
// fetch when section reloads in editor
document.addEventListener("shopify:section:load", function(event) {
  if (document.querySelector('[data-section-id="' + event.detail.sectionId + '"].related-products')) {
    loadProductRecommendationsIntoSection();
  }
});
// Fetching the recommendations on page load
loadProductRecommendationsIntoSection();

  } catch(e) { console.error(e); }
})();
})();
